// ==================== SERVICIO DE CERTIFICADOS (módulo Recepción) ====================
// Maneja todas las operaciones CRUD de certificados, completados y secciones

import api, { ejecutarConReintentos } from './api';

const certificadosService = {
  // ==================== CERTIFICADOS ACTIVOS ====================

  async obtenerCertificados() {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.get('/certificados');
      });
      return response.data.certificados || [];
    } catch (error) {
      console.error('❌ Error al obtener certificados:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener certificados' };
    }
  },

  async crearCertificado(datos) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.post('/certificados', datos);
      }, 3);
      return response.data.certificado;
    } catch (error) {
      console.error('❌ Error al crear certificado:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al crear certificado' };
    }
  },

  async actualizarCertificado(idCertificado, datosActualizados) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.put(`/certificados/${idCertificado}`, datosActualizados);
      });
      return response.data.certificado;
    } catch (error) {
      console.error('❌ Error al actualizar certificado:', error.response?.data || error.message);
      throw error;
    }
  },

  async eliminarCertificado(idCertificado) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.delete(`/certificados/${idCertificado}`);
      });
      return response.data;
    } catch (error) {
      if (error.response?.status !== 404) {
        console.error('❌ Error al eliminar certificado:', error.response?.data || error.message);
      }
      throw error;
    }
  },

  // ==================== RECEPCIÓN DE OBRA ====================

  async obtenerCertificadosObra() {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.get('/certificados?tipo=recepcion_obra');
      });
      return response.data.certificados || [];
    } catch (error) {
      console.error('❌ Error al obtener certificados de obra:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener certificados de obra' };
    }
  },

  async crearCertificadoObra(datos) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.post('/certificados', { ...datos, tipo: 'recepcion_obra' });
      }, 3);
      return response.data.certificado;
    } catch (error) {
      console.error('❌ Error al crear certificado de obra:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al crear certificado de obra' };
    }
  },

  async actualizarMesesRecepcionObra(mesesContractual, mesesProgramado) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.put('/certificados/config-fechas-recepcion-obra', {
          mesesContractual, mesesProgramado
        });
      });
      return response.data;
    } catch (error) {
      console.error('❌ Error al actualizar meses de recepción de obra:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al actualizar meses de recepción de obra' };
    }
  },

  // ==================== CERTIFICADOS COMPLETADOS ====================

  async actualizarFechasRecepcion(datos) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.put('/certificados/config-fechas-recepcion', datos);
      });
      return response.data;
    } catch (error) {
      console.error('❌ Error al actualizar fechas de recepción:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al actualizar fechas de recepción' };
    }
  },

  async completarCertificado(idCertificado, fechaReal) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.post(`/certificados-completados/completar/${idCertificado}`, { fechaReal });
      });
      return response.data.certificadoCompletado;
    } catch (error) {
      console.error('❌ Error al completar certificado:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al completar certificado' };
    }
  },

  async obtenerCompletados() {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.get('/certificados-completados');
      });
      return response.data.certificados || [];
    } catch (error) {
      console.error('❌ Error al obtener certificados completados:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener certificados completados' };
    }
  },

  async restaurarCertificado(idCompletado) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.post(`/certificados-completados/restaurar/${idCompletado}`);
      });
      return response.data.certificado;
    } catch (error) {
      console.error('❌ Error al restaurar certificado:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al restaurar certificado' };
    }
  },

  // ==================== SECCIONES RECEPCIÓN ====================

  async obtenerSecciones() {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.get('/secciones-recepcion');
      });
      return response.data.secciones || [];
    } catch (error) {
      console.error('❌ Error al obtener secciones de recepción:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener secciones' };
    }
  },

  async crearSeccion(datos) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.post('/secciones-recepcion', datos);
      });
      return response.data.seccion;
    } catch (error) {
      console.error('❌ Error al crear sección de recepción:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al crear sección' };
    }
  },

  async eliminarSeccion(idSeccion) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.delete(`/secciones-recepcion/${idSeccion}`);
      });
      return response.data;
    } catch (error) {
      console.error('❌ Error al eliminar sección de recepción:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al eliminar sección' };
    }
  },

  // ==================== DOCUMENTOS DENTRO DE PARTIDA ====================

  async agregarDocumento(idCertificado, datos) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.post(`/certificados/${idCertificado}/documentos`, datos);
      }, 3);
      return response.data.certificado;
    } catch (error) {
      console.error('❌ Error al agregar documento:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al agregar documento' };
    }
  },

  async actualizarDocumento(idCertificado, idDocumento, datos) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.put(`/certificados/${idCertificado}/documentos/${idDocumento}`, datos);
      });
      return response.data.certificado;
    } catch (error) {
      console.error('❌ Error al actualizar documento:', error.response?.data || error.message);
      throw error;
    }
  },

  async eliminarDocumento(idCertificado, idDocumento) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.delete(`/certificados/${idCertificado}/documentos/${idDocumento}`);
      });
      return response.data.certificado;
    } catch (error) {
      console.error('❌ Error al eliminar documento:', error.response?.data || error.message);
      throw error;
    }
  },

  async toggleDocumentoCompletado(idCertificado, idDocumento) {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.put(`/certificados/${idCertificado}/documentos/${idDocumento}/completar`);
      });
      return response.data.certificado;
    } catch (error) {
      console.error('❌ Error al toggle documento completado:', error.response?.data || error.message);
      throw error;
    }
  }
};

export default certificadosService;
